document.querySelectorAll('.open-folder-wrapper').forEach((wrapper) => {
    const controls = Array.from(wrapper.querySelectorAll('.tab-controls .tab-control'));
    const panels   = Array.from(wrapper.querySelectorAll('.tab-panels .tab-panel'));

    controls.forEach((control) => {
        control.addEventListener('click', () => {
            const target = control.getAttribute('data-folder-panel-control');
            const targetPanel = wrapper.querySelector(`.tab-panels .tab-panel[data-folder-panel="${target}"]`);
            if (!targetPanel) return;

            controls.forEach((c) => c.classList.remove('active'));
            panels.forEach((p) => p.classList.remove('active'));

            control.classList.add('active');
            targetPanel.classList.add('active');
        });
    });
});
